const sequence =
  '1qaz2wsx3edc4rfv5tgb6yhn7ujm8ik9ol0p1QAZ2WSX3EDC4RFV5TGB6YHN7UJM8IK9OL0P';

export const readField = (name, src, defVal) => {
  if (!src) {
    return defVal;
  }

  const path = name.split('.');

  if (path.length > 1) {
    for (const subpath of path) {
      if (!src) {
        return defVal;
      }

      src = src[subpath];
    }

    return getDefaultValue(src, defVal);
  }

  return getDefaultValue(src[name], defVal);
};

export const randomKey = length => {
  let key = '';

  for (let i = 0; i < length; ++i) {
    key += sequence.charAt(Math.random() * sequence.length);
  }

  return key;
};

export const getDefaultValue = (val, defVal) =>
  val !== null && val !== undefined ? val : defVal;

export const getNumber = (val, defVal) => {
  if (typeof val === 'number') {
    return val;
  }

  if (typeof val === 'string') {
    const n = Number(val);

    if (!isNaN(n)) {
      return n;
    }
  }

  return defVal || 0;
};
